var render, staticRenderFns
import script from "./componentSelector.vue?vue&type=script&lang=js"
export * from "./componentSelector.vue?vue&type=script&lang=js"
import style0 from "./componentSelector.vue?vue&type=style&index=0&id=32c3a3e9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports